/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_CardInputs */

const vi_payment_method_card = /** @type {(inputs: Payment_Method_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ`)
};

/**

* @param {Payment_Method_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_method_card = /** @type {((inputs?: Payment_Method_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_CardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_method_card(inputs)
});